import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormsModule } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import * as _ from 'lodash-es';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatButton } from '@angular/material/button';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
// import { UrlService } from 'src/app/services/url.service';



export interface RadioSelectDialogOptions {
    title: string;
    valid: string;
    text?: string;
    multiple?: boolean;
    data?: any[];
    defaultValue: any;
    predicate?: (v: any) => boolean;
    display?: (v: any) => string;
    map?: (v: any) => any;
}

@Component({
    selector: 'app-radio-select-dialog',
    templateUrl: './radio-select-dialog.component.html',
    styleUrls: ['./radio-select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, MatRadioGroup, FormsModule, RxReactiveFormsModule, MatRadioButton, MatDialogActions, MatButton, MatDialogClose, UpperCasePipe, TranslatePipe]
})
export class RadioSelectDialog extends FormDialogComponent implements OnInit {
    config: RadioSelectDialogOptions;


    text: string = '';
    selected: any;

    protected _data: any[] = [];
    get data(): any[] {
        return this._data.filter(this.predicate);
    }
    predicate: (v: any) => boolean;
    display: (v: any) => string;
    map: (v: any) => any;

    get isValid(): boolean { return this.form.valid; }

    constructor() {
        const config = inject<RadioSelectDialogOptions>(MAT_DIALOG_DATA);

        super();
        this.config = config;


        // INIT FROM OPTIONS
        this.text = config.text || '';
        this._data = config.data || [];
        this.selected = config.defaultValue || null;
        this.predicate = config.predicate || ((v: any) => true);
        this.display = config.display || ((v: any) => v);
        this.map = config.map || ((v: any) => v);
    }

    submit() {
        this.dialogRef.close(_.cloneDeep(this.selected));
    }
}
